<script setup lang="ts">
const props = defineProps<{
  label: string
  icon?: string
}>()
</script>

<template>
  <span
    class="relative text-sm text-n-600 bg-n-10 hover:bg-primary-10 block py-2 px-2 text-center rounded-md flex items-center justify-center cursor-pointer"
  >
    <img v-if="props.icon" :src="props.icon" alt="" class="w-[24px] h-[24px] block mr-2">
    {{ props.label }}</span>
</template>
